/** Move to a final list index without mutating either the list or its items. */
export function reorderTaskTemplateItems<T>(items: readonly T[], from: number, to: number): T[] {
  const next = [...items];
  if (!Number.isInteger(from) || !Number.isInteger(to) || from < 0 || to < 0 || from >= next.length || to >= next.length || from === to) return next;
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

export function moveTaskTemplateItem<T>(items: readonly T[], index: number, direction: 'up' | 'down'): T[] {
  return reorderTaskTemplateItems(items, index, index + (direction === 'up' ? -1 : 1));
}
